(function () {
  'use strict';

  function normalize(val) {
    if (val == null) return '';

    if (typeof val === 'string') return val.trim().toLowerCase();

    if (Array.isArray(val)) {
      if (!val.length) return '';
      return normalize(val[0]);
    }

    if (typeof val === 'object') {
      if (val.value != null) return normalize(val.value);
      if (val.label != null) return normalize(val.label);
      if (val.name != null) return normalize(val.name);
      return '';
    }

    return String(val).trim().toLowerCase();
  }

  function titleText(product) {
    return ((product.title || '') + ' ' + (product.handle || '')).toLowerCase();
  }

  function extractShapeFallback(product) {
    var text = titleText(product);

    if (text.indexOf('round') > -1) return 'round';
    if (text.indexOf('princess') > -1) return 'princess';
    if (text.indexOf('radiant') > -1) return 'radiant';
    if (text.indexOf('pear') > -1) return 'pear';
    if (text.indexOf('emerald') > -1) return 'emerald';
    if (text.indexOf('asscher') > -1) return 'asscher';
    if (text.indexOf('marquise') > -1) return 'marquise';
    if (text.indexOf('oval') > -1) return 'oval';
    if (text.indexOf('heart') > -1) return 'heart';
    if (text.indexOf('cushion') > -1) return 'cushion';
    if (text.indexOf('cush') > -1) return 'cushion';
    if (text.indexOf('hexagon') > -1) return 'hexagon';
    if (text.indexOf('baguette') > -1) return 'baguette';
    if (text.indexOf('trilliant') > -1) return 'trilliant';
    if (text.indexOf('square') > -1) return 'square';

    return '';
  }

  function extractColorFallback(product) {
    var text = titleText(product);
    var match = text.match(/\b(d|e|f|g|h)\b/);
    return match ? match[1] : '';
  }

  function extractClarityFallback(product) {
    var text = titleText(product);

    if (text.indexOf('vvs2') > -1) return 'vvs-2';
    if (text.indexOf('vvs1') > -1) return 'vvs-1';
    if (text.indexOf('vs2') > -1) return 'vs-2';
    if (text.indexOf('vs1') > -1) return 'vs-1';
    if (text.indexOf('si3') > -1) return 'si-3';
    if (text.indexOf('si2') > -1) return 'si-2';
    if (text.indexOf('si1') > -1) return 'si-1';
    if (text.indexOf('i3') > -1) return 'i-3';
    if (text.indexOf('i2') > -1) return 'i-2';
    if (text.indexOf('i1') > -1) return 'i-1';
    if (text.indexOf('/if') > -1 || text.indexOf(' if ') > -1) return 'if';
    if (text.indexOf('/fl') > -1 || text.indexOf(' fl ') > -1) return 'fl';

    return '';
  }

  function extractCaratFallback(product) {
    var text = titleText(product);
    var match = text.match(/(\d+(\.\d+)?)\s*ct/i);
    return match ? parseFloat(match[1]) : 0;
  }

  function labelize(val) {
    return String(val || '')
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (m) { return m.toUpperCase(); });
  }

  function uniqueElements(items) {
    return items.filter(function (item, index) {
      return item && items.indexOf(item) === index;
    });
  }

  function setPressedState(element, isPressed) {
    if (!element || element.tagName !== 'BUTTON') return;
    element.setAttribute('aria-pressed', isPressed ? 'true' : 'false');
  }

  var FILTER_KEYS = [
    'shape',
    'clarity',
    'cut',
    'cut_type',
    'diamond_color',
    'diamond_type',
    'polish',
    'symmetry'
  ];

  function findGridRoot() {
    return (
      document.getElementById('CollectionProductGrid') ||
      document.querySelector('[data-product-grid]') ||
      document.querySelector('.main-collection-product-grid') ||
      document.querySelector('.template-collection [data-product-container]') ||
      document.querySelector('.template-collection .product-grid') ||
      document.querySelector('.template-collection .grid')
    );
  }

  function findGridContainer() {
    var root = findGridRoot();
    if (!root) return null;

    if (root.matches('[data-product-container]')) return root;

    return (
      root.querySelector('[data-product-container]') ||
      root.querySelector('.product-grid') ||
      root.querySelector('ul.grid') ||
      root.querySelector('.grid') ||
      root
    );
  }

  function findDirectChildCard(node, container) {
    var current = node;

    while (current && current !== container) {
      if (current.parentElement === container) return current;
      current = current.parentElement;
    }

    return null;
  }

  function getCardProductHandle(card) {
    if (!card) return '';

    if (card.dataset.productHandle) return String(card.dataset.productHandle);
    if (card.getAttribute('data-product-handle')) return String(card.getAttribute('data-product-handle'));

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^?#/]+)/);
    return match ? String(match[1]) : '';
  }

  function getCardProductId(card) {
    if (!card) return '';

    return String(
      card.getAttribute('data-product-id') ||
      card.dataset.productId ||
      ''
    );
  }

  function getCards() {
    var container = findGridContainer();
    if (!container) return [];

    var directChildren = Array.prototype.filter.call(container.children, function (child) {
      return !!getCardProductHandle(child);
    });

    if (directChildren.length) return directChildren;

    var linkedCards = Array.prototype.map.call(
      container.querySelectorAll('a[href*="/products/"]'),
      function (link) {
        return findDirectChildCard(link, container);
      }
    );

    return uniqueElements(linkedCards);
  }

  function initSection(section) {
    if (!section || section.dataset.diamondFilterReady === 'true') return;

    var dataEl = section.querySelector('[data-diamond-product-data]');
    var countEl = section.querySelector('[data-diamond-result-count]');
    var applyBtn = section.querySelector('[data-diamond-apply-filters]');
    var resetBtn = section.querySelector('[data-diamond-reset-all]');
    var inlineResetBtn = section.querySelector('[data-diamond-reset-all-inline]');
    var tagsWrap = section.querySelector('[data-diamond-active-tags]');
    var tagsList = section.querySelector('[data-diamond-tags-list]');
    var currencySymbol = section.dataset.currencySymbol || '$';

    if (!dataEl || !countEl || !applyBtn || !resetBtn) {
      console.warn('[Diamond Filter] Required section elements missing');
      return;
    }

    var rawProducts = [];

    try {
      rawProducts = JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
      console.error('[Diamond Filter] Could not parse product JSON', error);
      return;
    }

    function normalizeProduct(product) {
      var shape = normalize(product.shape) || extractShapeFallback(product);
      var clarity = normalize(product.clarity) || extractClarityFallback(product);
      var diamondColor = normalize(product.diamond_color) || extractColorFallback(product);
      var carat = parseFloat(normalize(product.carat)) || extractCaratFallback(product);

      return {
        id: String(product.id || ''),
        handle: String(product.handle || ''),
        title: product.title || '',
        price: parseFloat(product.price) || 0,
        carat: carat,
        shape: shape,
        clarity: clarity,
        cut: normalize(product.cut),
        cut_type: normalize(product.cut_type),
        diamond_color: diamondColor,
        diamond_type: normalize(product.diamond_type),
        polish: normalize(product.polish),
        symmetry: normalize(product.symmetry)
      };
    }

    var products = rawProducts.map(normalizeProduct);
    var existingIds = {};
    products.forEach(function (p) { existingIds[p.id] = true; });

    /* ── Fetch remaining pages via Section Rendering API ── */
    var paginationEl = section.querySelector('[data-diamond-pagination]');
    var paginationInfo = null;

    try {
      paginationInfo = paginationEl ? JSON.parse(paginationEl.textContent || '{}') : null;
    } catch (e) {
      paginationInfo = null;
    }

    if (paginationInfo && paginationInfo.totalPages > 1) {
      var totalPages = paginationInfo.totalPages;
      var sectionId = paginationInfo.sectionId;
      var collectionUrl = paginationInfo.collectionUrl || window.location.pathname;
      var fetched = 0;

      for (var page = 2; page <= totalPages; page++) {
        (function (pageNum) {
          var url = collectionUrl + '?page=' + pageNum + '&section_id=' + sectionId;

          fetch(url)
            .then(function (resp) { return resp.text(); })
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var jsonEl = doc.querySelector('[data-diamond-product-data]');

              if (jsonEl) {
                try {
                  var pageProducts = JSON.parse(jsonEl.textContent || '[]');

                  pageProducts.forEach(function (raw) {
                    var p = normalizeProduct(raw);
                    if (!existingIds[p.id]) {
                      existingIds[p.id] = true;
                      products.push(p);
                    }
                  });
                } catch (e) {
                  console.warn('[Diamond Filter] Parse error on page ' + pageNum, e);
                }
              }
            })
            .catch(function (err) {
              console.warn('[Diamond Filter] Fetch error on page ' + pageNum, err);
            })
            .finally(function () {
              fetched++;
              if (fetched >= totalPages - 1) {
                updateCount(products.length);
                console.log('[Diamond Filter] All pages loaded. Total products:', products.length);
              }
            });
        })(page);
      }
    }

    var state = {
      shape: [],
      clarity: [],
      cut: [],
      cut_type: [],
      diamond_color: [],
      diamond_type: [],
      polish: [],
      symmetry: [],
      price: { min: 0, max: Infinity },
      carat: { min: 0, max: Infinity }
    };

    var filterApplied = false;
    var observerAttached = false;
    var mutationDebounce = null;

    function showAllCards() {
      getCards().forEach(function (card) {
        card.classList.remove('diamond-filter-hidden');
        card.hidden = false;
        card.setAttribute('aria-hidden', 'false');
      });
    }

    function productMatchesArrayFilter(productValue, selectedValues) {
      if (!selectedValues.length) return true;
      if (!productValue) return false;

      if (selectedValues.indexOf(productValue) > -1) return true;

      if (selectedValues.indexOf('cushion') > -1) {
        if (
          productValue === 'cushion' ||
          productValue === 'cush-mod' ||
          productValue === 'cush-brill' ||
          productValue === 'elongated-cushion'
        ) {
          return true;
        }
      }

      if (selectedValues.indexOf('elongated-cushion') > -1) {
        if (
          productValue === 'elongated-cushion' ||
          productValue === 'cush-mod' ||
          productValue === 'cush-brill'
        ) {
          return true;
        }
      }

      if (selectedValues.indexOf('marquise') > -1 && productValue === 'dutch-marquise') {
        return true;
      }

      return false;
    }

    function matchesFilters(product) {
      if (!productMatchesArrayFilter(product.shape, state.shape)) return false;
      if (!productMatchesArrayFilter(product.clarity, state.clarity)) return false;
      if (!productMatchesArrayFilter(product.cut, state.cut)) return false;
      if (!productMatchesArrayFilter(product.cut_type, state.cut_type)) return false;
      if (!productMatchesArrayFilter(product.diamond_color, state.diamond_color)) return false;
      if (!productMatchesArrayFilter(product.diamond_type, state.diamond_type)) return false;
      if (!productMatchesArrayFilter(product.polish, state.polish)) return false;
      if (!productMatchesArrayFilter(product.symmetry, state.symmetry)) return false;

      if (product.price < state.price.min || product.price > state.price.max) return false;
      if (product.carat < state.carat.min || product.carat > state.carat.max) return false;

      return true;
    }

    function getFilteredProducts() {
      return products.filter(matchesFilters);
    }

    function hasAnyActiveFilters() {
      for (var index = 0; index < FILTER_KEYS.length; index++) {
        if (state[FILTER_KEYS[index]].length) return true;
      }

      var priceSlider = section.querySelector('.diamond-filter__range-slider[data-filter="price"]');
      var caratInputs = section.querySelector('.diamond-filter__carat-inputs[data-filter="carat"]');

      if (priceSlider) {
        var priceMin = parseFloat(priceSlider.dataset.min);
        var priceMax = parseFloat(priceSlider.dataset.max);

        if (state.price.min > priceMin || state.price.max < priceMax) return true;
      }

      if (caratInputs) {
        var caratMin = parseFloat(caratInputs.dataset.min) || 0;
        var caratMax = parseFloat(caratInputs.dataset.max) || 10;

        if (state.carat.min > caratMin || state.carat.max < caratMax) return true;
      }

      return false;
    }

    function getVisiblePageMatchCount(filteredProducts) {
      var cards = getCards();
      var allowedIds = {};
      var allowedHandles = {};
      var visibleMatches = 0;

      filteredProducts.forEach(function (product) {
        allowedIds[String(product.id)] = true;
        allowedHandles[String(product.handle)] = true;
      });

      cards.forEach(function (card) {
        var cardId = getCardProductId(card);
        var cardHandle = getCardProductHandle(card);

        if ((cardId && allowedIds[cardId]) || (cardHandle && allowedHandles[cardHandle])) {
          visibleMatches++;
        }
      });

      return visibleMatches;
    }

    function updateCount(totalMatches, visiblePageCount) {
      if (typeof visiblePageCount === 'number') {
        countEl.textContent = visiblePageCount + ' shown';
        return;
      }

      countEl.textContent = totalMatches + ' diamond' + (totalMatches === 1 ? '' : 's');
    }

    function updateTags() {
      if (!tagsWrap || !tagsList) return;

      var tags = [];

      FILTER_KEYS.forEach(function (key) {
        state[key].forEach(function (value) {
          tags.push({
            key: key,
            value: value,
            label: labelize(key) + ': ' + labelize(value)
          });
        });
      });

      var priceSlider = section.querySelector('.diamond-filter__range-slider[data-filter="price"]');
      if (priceSlider) {
        var priceMin = parseFloat(priceSlider.dataset.min);
        var priceMax = parseFloat(priceSlider.dataset.max);

        if (state.price.min > priceMin || state.price.max < priceMax) {
          tags.push({
            key: 'price',
            value: '',
            label: 'Price: ' + currencySymbol + state.price.min.toLocaleString() + ' - ' + currencySymbol + state.price.max.toLocaleString()
          });
        }
      }

      var caratInputs = section.querySelector('.diamond-filter__carat-inputs[data-filter="carat"]');
      if (caratInputs) {
        var caratMin = parseFloat(caratInputs.dataset.min) || 0;
        var caratMax = parseFloat(caratInputs.dataset.max) || 10;

        if (state.carat.min > caratMin || state.carat.max < caratMax) {
          tags.push({
            key: 'carat',
            value: '',
            label: 'Carat: ' + state.carat.min + ' - ' + (state.carat.max >= caratMax ? '10+' : state.carat.max) + ' ct'
          });
        }
      }

      if (!tags.length) {
        tagsWrap.style.display = 'none';
        tagsList.innerHTML = '';
        return;
      }

      tagsWrap.style.display = '';
      tagsList.innerHTML = tags.map(function (tag) {
        return (
          '<span class="diamond-filter__tag">' +
            tag.label +
            '<button class="diamond-filter__tag-remove" type="button" aria-label="Remove ' + tag.label + '" data-key="' + tag.key + '" data-value="' + tag.value + '">&times;</button>' +
          '</span>'
        );
      }).join('');

      tagsList.querySelectorAll('.diamond-filter__tag-remove').forEach(function (button) {
        button.addEventListener('click', function () {
          removeTag(button.dataset.key, button.dataset.value);
        });
      });
    }

    function onFilterChange() {
      var filteredProducts = getFilteredProducts();
      var visibleMatches = getVisiblePageMatchCount(filteredProducts);

      updateCount(filteredProducts.length, visibleMatches);
      updateTags();
    }

    function applyCurrentFilters() {
      var cards = getCards();

      if (!cards.length) {
        updateCount(getFilteredProducts().length);
        return;
      }

      if (!filterApplied && !hasAnyActiveFilters()) {
        showAllCards();
        updateCount(products.length);
        return;
      }

      var filteredProducts = getFilteredProducts();
      var allowedIds = {};
      var allowedHandles = {};
      var shown = 0;

      filteredProducts.forEach(function (product) {
        allowedIds[String(product.id)] = true;
        allowedHandles[String(product.handle)] = true;
      });

      cards.forEach(function (card) {
        var cardId = getCardProductId(card);
        var cardHandle = getCardProductHandle(card);
        var match = false;

        if (cardId && allowedIds[cardId]) {
          match = true;
        } else if (cardHandle && allowedHandles[cardHandle]) {
          match = true;
        }

        if (match) {
          card.classList.remove('diamond-filter-hidden');
          card.hidden = false;
          card.setAttribute('aria-hidden', 'false');
          shown++;
        } else {
          card.classList.add('diamond-filter-hidden');
          card.hidden = true;
          card.setAttribute('aria-hidden', 'true');
        }
      });

      updateCount(filteredProducts.length, shown);
    }

    function attachGridObserver() {
      if (observerAttached) return true;

      var container = findGridContainer();
      if (!container) return false;

      var observer = new MutationObserver(function (mutations) {
        var hasChanges = mutations.some(function (mutation) {
          return (
            (mutation.addedNodes && mutation.addedNodes.length > 0) ||
            (mutation.removedNodes && mutation.removedNodes.length > 0)
          );
        });

        if (!hasChanges) return;

        clearTimeout(mutationDebounce);
        mutationDebounce = setTimeout(function () {
          if (filterApplied || hasAnyActiveFilters()) {
            applyCurrentFilters();
          } else {
            showAllCards();
          }
        }, 120);
      });

      observer.observe(container, { childList: true, subtree: true });
      observerAttached = true;
      return true;
    }

    function removeTag(key, value) {
      if (FILTER_KEYS.indexOf(key) > -1) {
        state[key] = state[key].filter(function (item) {
          return item !== value;
        });

        section.querySelectorAll('[data-filter-key="' + key + '"][data-filter-value="' + value + '"]').forEach(function (element) {
          element.classList.remove('is-active');
          setPressedState(element, false);
        });
      } else if (key === 'price') {
        resetRangeSlider('price');
      } else if (key === 'carat') {
        resetCaratInputs();
      }

      onFilterChange();

      if (filterApplied || hasAnyActiveFilters()) {
        applyCurrentFilters();
      }
    }

    function resetRangeSlider(key) {
      var slider = section.querySelector('.diamond-filter__range-slider[data-filter="' + key + '"]');
      if (!slider) return;

      var dataMin = parseFloat(slider.dataset.min);
      var dataMax = parseFloat(slider.dataset.max);
      var minInput = slider.querySelector('.diamond-filter__range-input--min');
      var maxInput = slider.querySelector('.diamond-filter__range-input--max');
      var numMin = slider.querySelector('.diamond-filter__range-number[data-bound="min"]');
      var numMax = slider.querySelector('.diamond-filter__range-number[data-bound="max"]');
      var fill = slider.querySelector('.diamond-filter__range-fill');

      if (minInput) minInput.value = dataMin;
      if (maxInput) maxInput.value = dataMax;
      if (numMin) numMin.value = dataMin;
      if (numMax) numMax.value = dataMax;

      state[key] = { min: dataMin, max: dataMax };

      if (fill) {
        fill.style.left = '0%';
        fill.style.width = '100%';
      }
    }

    function resetCaratInputs() {
      var caratInputs = section.querySelector('.diamond-filter__carat-inputs[data-filter="carat"]');
      if (!caratInputs) return;

      var dataMin = parseFloat(caratInputs.dataset.min) || 0;
      var dataMax = parseFloat(caratInputs.dataset.max) || 10;
      
      var numMin = caratInputs.querySelector('.diamond-filter__carat-number[data-bound="min"]');
      var numMax = caratInputs.querySelector('.diamond-filter__carat-number[data-bound="max"]');

      if (numMin) numMin.value = '';
      if (numMax) numMax.value = '';

      state.carat = { min: dataMin, max: dataMax };

      section.querySelectorAll('.diamond-filter__preset-btn.is-active').forEach(function (btn) {
        btn.classList.remove('is-active');
        setPressedState(btn, false);
      });
    }

    /* ── Carat Logic ── */
    var caratInputs = section.querySelector('.diamond-filter__carat-inputs[data-filter="carat"]');
    if (caratInputs) {
      var crDataMin = parseFloat(caratInputs.dataset.min) || 0;
      var crDataMax = parseFloat(caratInputs.dataset.max) || 10;
      var crNumMin = caratInputs.querySelector('.diamond-filter__carat-number[data-bound="min"]');
      var crNumMax = caratInputs.querySelector('.diamond-filter__carat-number[data-bound="max"]');
      var presetBtns = section.querySelectorAll('.diamond-filter__preset-btn');

      state.carat = { min: crDataMin, max: crDataMax };

      function syncCaratFromNumbers(e) {
        presetBtns.forEach(function (btn) {
          btn.classList.remove('is-active');
          setPressedState(btn, false);
        });

        var lowValue = crNumMin.value === '' ? crDataMin : parseFloat(crNumMin.value);
        var highValue = crNumMax.value === '' ? crDataMax : parseFloat(crNumMax.value);

        if (isNaN(lowValue)) lowValue = crDataMin;
        if (isNaN(highValue)) highValue = crDataMax;

        lowValue = Math.max(crDataMin, lowValue);
        highValue = Math.max(crDataMin, Math.min(highValue, crDataMax));

        if (lowValue > highValue) {
          var temp = lowValue;
          lowValue = highValue;
          highValue = temp;
        }

        if (crNumMin.value !== '') crNumMin.value = lowValue;
        if (crNumMax.value !== '') crNumMax.value = highValue;

        state.carat = { min: lowValue, max: highValue };
        
        onFilterChange();
        if (filterApplied) applyCurrentFilters();
      }

      crNumMin.addEventListener('change', syncCaratFromNumbers);
      crNumMax.addEventListener('change', syncCaratFromNumbers);

      presetBtns.forEach(function (btn) {
        setPressedState(btn, false);
        btn.addEventListener('click', function () {
          var isCurrentlyActive = btn.classList.contains('is-active');
          
          presetBtns.forEach(function (b) {
            b.classList.remove('is-active');
            setPressedState(b, false);
          });

          if (isCurrentlyActive) {
            crNumMin.value = '';
            crNumMax.value = '';
            state.carat = { min: crDataMin, max: crDataMax };
          } else {
            btn.classList.add('is-active');
            setPressedState(btn, true);
            var pMin = parseFloat(btn.dataset.presetMin);
            var pMax = btn.dataset.presetMax ? parseFloat(btn.dataset.presetMax) : crDataMax;
            
            crNumMin.value = pMin;
            crNumMax.value = isNaN(pMax) || pMax === crDataMax ? '' : pMax;
            state.carat = { min: pMin, max: pMax };
          }

          onFilterChange();
          if (filterApplied) applyCurrentFilters();
        });
      });
    }

    var standardColors = ['d','e','f','g','h','i','j','k','l','m','n','p','q','r','s','t','u','v','w','x','y','z'];
    var clarityValues = ['fl','if','vvs-1','vvs-2','vs-1','vs-2','si-1','si-2','si-3','i-1','i-2','i-3'];

    function handleRangeSelection(key, value, orderedArray) {
      var activeItems = state[key].filter(function(v) { return orderedArray.indexOf(v) > -1; });
      
      if (activeItems.length === 0) {
        state[key].push(value);
      } else if (activeItems.length === 1 && activeItems[0] !== value) {
        var startIdx = orderedArray.indexOf(activeItems[0]);
        var endIdx = orderedArray.indexOf(value);
        var minIdx = Math.min(startIdx, endIdx);
        var maxIdx = Math.max(startIdx, endIdx);
        
        state[key] = state[key].filter(function(v) { return orderedArray.indexOf(v) === -1; });
        for (var i = minIdx; i <= maxIdx; i++) {
          state[key].push(orderedArray[i]);
        }
      } else if (activeItems.length === 1 && activeItems[0] === value) {
        state[key] = state[key].filter(function(v) { return orderedArray.indexOf(v) === -1; });
      } else {
        state[key] = state[key].filter(function(v) { return orderedArray.indexOf(v) === -1; });
        state[key].push(value);
      }

      section.querySelectorAll('[data-filter-key="' + key + '"]').forEach(function(btn) {
        var btnVal = normalize(btn.dataset.filterValue);
        if (state[key].indexOf(btnVal) > -1) {
          btn.classList.add('is-active');
          setPressedState(btn, true);
        } else {
          btn.classList.remove('is-active');
          setPressedState(btn, false);
        }
      });
    }

    section.querySelectorAll('[data-filter-key][data-filter-value]').forEach(function (button) {
      setPressedState(button, false);

      button.addEventListener('click', function () {
        var key = button.dataset.filterKey;
        var value = normalize(button.dataset.filterValue);

        if (!key || FILTER_KEYS.indexOf(key) === -1 || !value) return;

        if (key === 'diamond_color' && standardColors.indexOf(value) > -1) {
          handleRangeSelection(key, value, standardColors);
        } else if (key === 'clarity' && clarityValues.indexOf(value) > -1) {
          handleRangeSelection(key, value, clarityValues);
        } else {
          // Default toggle behavior for shapes, fancy colors, cut, etc.
          var index = state[key].indexOf(value);

          if (index > -1) {
            state[key].splice(index, 1);
            button.classList.remove('is-active');
            setPressedState(button, false);
          } else {
            state[key].push(value);
            button.classList.add('is-active');
            setPressedState(button, true);
          }
        }

        onFilterChange();

        if (filterApplied) {
          applyCurrentFilters();
        }
      });
    });

    section.querySelectorAll('.diamond-filter__range-slider').forEach(function (slider) {
      var key = slider.dataset.filter;
      var minInput = slider.querySelector('.diamond-filter__range-input--min');
      var maxInput = slider.querySelector('.diamond-filter__range-input--max');
      var numMin = slider.querySelector('.diamond-filter__range-number[data-bound="min"]');
      var numMax = slider.querySelector('.diamond-filter__range-number[data-bound="max"]');
      var fill = slider.querySelector('.diamond-filter__range-fill');

      if (!key || !minInput || !maxInput || !numMin || !numMax || !fill) return;

      var dataMin = parseFloat(slider.dataset.min);
      var dataMax = parseFloat(slider.dataset.max);

      state[key] = { min: dataMin, max: dataMax };

      function updateFill() {
        var lowValue = parseFloat(minInput.value);
        var highValue = parseFloat(maxInput.value);
        var range = dataMax - dataMin;

        if (range <= 0) return;

        fill.style.left = ((lowValue - dataMin) / range * 100) + '%';
        fill.style.width = ((highValue - lowValue) / range * 100) + '%';
      }

      function syncFromSliders() {
        var lowValue = parseFloat(minInput.value);
        var highValue = parseFloat(maxInput.value);

        if (lowValue > highValue) {
          var temp = lowValue;
          lowValue = highValue;
          highValue = temp;
        }

        minInput.value = lowValue;
        maxInput.value = highValue;
        numMin.value = lowValue;
        numMax.value = highValue;
        state[key] = { min: lowValue, max: highValue };

        updateFill();
        onFilterChange();

        if (filterApplied) {
          applyCurrentFilters();
        }
      }

      function syncFromNumbers() {
        var lowValue = parseFloat(numMin.value);
        var highValue = parseFloat(numMax.value);

        if (isNaN(lowValue)) lowValue = dataMin;
        if (isNaN(highValue)) highValue = dataMax;

        lowValue = Math.max(dataMin, Math.min(lowValue, dataMax));
        highValue = Math.max(dataMin, Math.min(highValue, dataMax));

        if (lowValue > highValue) {
          var temp = lowValue;
          lowValue = highValue;
          highValue = temp;
        }

        minInput.value = lowValue;
        maxInput.value = highValue;
        numMin.value = lowValue;
        numMax.value = highValue;
        state[key] = { min: lowValue, max: highValue };

        updateFill();
        onFilterChange();

        if (filterApplied) {
          applyCurrentFilters();
        }
      }

      minInput.addEventListener('input', syncFromSliders);
      maxInput.addEventListener('input', syncFromSliders);
      numMin.addEventListener('change', syncFromNumbers);
      numMax.addEventListener('change', syncFromNumbers);

      updateFill();
    });

    applyBtn.addEventListener('click', function () {
      filterApplied = true;
      applyCurrentFilters();
    });

    resetBtn.addEventListener('click', function () {
      FILTER_KEYS.forEach(function (key) {
        state[key] = [];
      });

      section.querySelectorAll('.is-active').forEach(function (element) {
        element.classList.remove('is-active');
        setPressedState(element, false);
      });

      resetRangeSlider('price');
      resetCaratInputs();

      filterApplied = false;
      updateCount(products.length);
      updateTags();
      showAllCards();
    });

    if (inlineResetBtn) {
      inlineResetBtn.addEventListener('click', function () {
        resetBtn.click();
      });
    }

    attachGridObserver();
    updateCount(products.length);
    updateTags();
    showAllCards();

    section.dataset.diamondFilterReady = 'true';
  }

  function bootSections(event) {
    if (event && event.target) {
      if (event.target.matches && event.target.matches('[data-diamond-filter-section]')) {
        initSection(event.target);
        return;
      }

      if (event.target.querySelectorAll) {
        event.target.querySelectorAll('[data-diamond-filter-section]').forEach(initSection);
        return;
      }
    }

    document.querySelectorAll('[data-diamond-filter-section]').forEach(initSection);
  }

  bootSections();
  document.addEventListener('shopify:section:load', bootSections);
  document.addEventListener('shopify:section:reorder', bootSections);
})();